import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigation } from '../../hooks/useNavigation';

export function JoinButton() {
  const { navigateToSection } = useNavigation();

  const handleClick = () => {
    navigateToSection('waitlist');
  };

  return (
    <button
      onClick={handleClick}
      className="hidden md:inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 
        text-white px-6 py-2.5 rounded-full hover:from-primary-600 hover:to-primary-700 
        transition-all transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg
        text-base font-medium"
    >
      Join Waitlist
      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
    </button>
  );
}